import { Helpers } from '../../../utils/helpers';
import useClubMemberSearch from './useClubMemberSearch';
import { ClubMemberLookup } from '../../../components/member/ClubMemberLookup/ClubMemberLookup';
import Container from '../../../components/ui/Container/Container';
import { ClubMemberEditor } from '../ClubMemberEditor/ClubMemberEditor';

export const ClubMemberSearch = () => {
  const manager = useClubMemberSearch();
  return (
    <>
      <Container visible={Helpers.isNullOrWhiteSpace(manager.clubMemberId)}>
        <div className="page-container mt-2">
          <ClubMemberLookup
            showInactiveFilter={true}
            clubMemberId={manager.clubMemberId}
            onChange={manager.clubMemberSelected}
          />
        </div>
      </Container>
      <ClubMemberEditor clubMemberId={manager.clubMemberId} />
    </>
  );
};
